<template>
  <div class="positionfixed">
    <Header></Header>
    <div class="pc_all EnterBrand">
      <loginWindow style="z-index: 999999" v-if="showLogin" @close="showLogin = false"></loginWindow>
      <div class="pc_all_content">
        <div class="EnterBrand_top">
          <div class="EnterBrand_top_title font38 animate__animated animate__fadeInDown">
            输入品牌开启LOGO创作之旅
          </div>
          <div class="EnterBrand_top_form">
            <div class="top_form_list animate__animated animate__fadeInDown"
              :class="{ active: isFirstInputFocused, active2: firstInputValue }">
              <div class="form_list_title font20">品牌名称（20 个字内）</div>
              <input type="text" class="font20" v-model="logoBrandName" @focus="handleFirstInputFocus"
                @blur="handleFirstInputBlur" @input="handleFirstInputChange" />
            </div>
            <div class="top_form_list animate__animated animate__fadeInDown"
              :class="{ active: isSecondInputFocused, active2: secondInputValue }">
              <div class="form_list_title font20">品牌英文名称或口号（选填）</div>
              <input type="text" class="font20" v-model="logoSlogan" @focus="handleSecondInputFocus"
                @blur="handleSecondInputBlur" @input="handleSecondInputChange" />
            </div>
            <div class="top_form_btn font20 animate__animated animate__fadeInDown" :class="{ active: isFormFilled }"
              @click="goToFreeCreation">
              <div class="form_btn_po">继续<span class="iconfont icon-xiangyou"></span></div>
            </div>
          </div>
        </div>
        <div class="EnterBrand_bottom">
          <div class="EnterBrand_bottom_top font20 animate__animated animate__fadeInDown">
            <div class="bottom_top_left">我们还将为您<span>生成VI示例</span></div>
            <div class="bottom_top_btn">
              <div class="top_btn_list top_btn_prev" @click="prevSlide">
                <span class="iconfont icon-xiangyou"></span>
              </div>
              <div class="top_btn_list top_btn_next" @click="nextSlide">
                <span class="iconfont icon-xiangyou"></span>
              </div>
            </div>
          </div>
          <div class="EnterBrand_bottom_content animate__animated animate__fadeInDown">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide bottom_content_list">
                  <img alt="" src="@a/ailogo/images/bg4.jpg" />
                </div>
                <div class="swiper-slide bottom_content_list">
                  <img alt="" src="@a/ailogo/images/bg5.jpg" />
                </div>
                <div class="swiper-slide bottom_content_list">
                  <img alt="" src="@a/ailogo/images/bg6.jpg" />
                </div>
                <div class="swiper-slide bottom_content_list">
                  <img alt="" src="@a/ailogo/images/bg7.jpg" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@c/header/header'
import Swiper from 'swiper'
import 'swiper/css/swiper.css';
import { mapState, mapMutations } from 'vuex'
import loginWindow from "@c/common/loginWindow/loginWindow";

export default {
  name: 'EnterBrand',
  data() {
    return {
      isFirstInputFocused: false,
      isSecondInputFocused: false,
      firstInputValue: false,
      secondInputValue: false,
      isFormFilled: false,
      swiperInstance: null, // 添加 Swiper 实例
      showLogin: false,
      logoBrandName: '', // 绑定品牌名称
      logoSlogan: '', // 绑定口号
    }
  },
  created() {
    //console.log('是否登录', this.$store.getters.isLogin);
    if (this.$store.getters.isLogin) {
    } else {
      //未登录需要会员强制登录
      //this.showLogin = true;
    }

    // 从 本地获取数据
    this.loadFromLocalStorage();

  },
  mounted() {
    // 初始化 Swiper 实例并保存到 data 中
    this.swiperInstance = new Swiper('.swiper-container', {
      slidesPerView: 4,
      spaceBetween: 20,
      loop: true
    })
  },
  components: {
    loginWindow,
    Header
  },
  computed: {
    ...mapState({
      brandName: state => state.brand.name,
      slogan: state => state.brand.slogan
    })
  },
  methods: {
    ...mapMutations({
      setBrandName: 'SET_BRAND_NAME',
      setSlogan: 'SET_SLOGAN'
    }),
    prevSlide() {
      if (this.swiperInstance) {
        // 确保 swiperInstance 存在
        this.swiperInstance.slidePrev()
        console.log('上一张')
        // 移除 swiper-slide 元素的动画类名
        this.$el.querySelectorAll('.swiper-slide').forEach((slide) => {
          slide.classList.remove('animate__fadeInRight')
        })
      }
    },
    nextSlide() {
      if (this.swiperInstance) {
        // 确保 swiperInstance 存在
        this.swiperInstance.slideNext()
        console.log('下一张')
        // 移除 swiper-slide 元素的动画类名
        this.$el.querySelectorAll('.swiper-slide').forEach((slide) => {
          slide.classList.remove('animate__fadeInRight')
        })
      }
    },
    handleFirstInputFocus() {
      this.isFirstInputFocused = true
    },
    handleFirstInputBlur() {
      this.isFirstInputFocused = false
    },
    handleFirstInputChange(event) {
      const value = event.target.value;
      this.firstInputValue = event.target.value !== ''
      this.setBrandName(value); // 存储品牌名称到 Vuex

      // 存储品牌名称到 localStorage
      localStorage.setItem('logoBrandName', value);

      this.checkFormFilled()
    },
    handleSecondInputFocus() {
      this.isSecondInputFocused = true
    },
    handleSecondInputBlur() {
      this.isSecondInputFocused = false
    },
    handleSecondInputChange(event) {
      const value = event.target.value;
      this.secondInputValue = event.target.value !== ''
      this.setSlogan(value); // 存储口号到 Vuex
      // 存储口号到 localStorage
      localStorage.setItem('logoSlogan', value);
      this.checkFormFilled()
    },
    checkFormFilled() {
      this.isFormFilled = this.firstInputValue
    },
    goToFreeCreation() {
      if (this.isFormFilled) {
        this.$emit('increase-progress')
        this.$router.push('/ailogo/FreeCreation/FreeCreation')
      }
    },

    // 从 本地获取数据
    loadFromLocalStorage() {
      // 从 localStorage 获取品牌名称
      const logoBrandName = localStorage.getItem('logoBrandName');
      if (logoBrandName) {
        this.logoBrandName = logoBrandName;
        this.firstInputValue = true;
      }
      // 从 localStorage 获取口号
      const logoSlogan = localStorage.getItem('logoSlogan');
      if (logoSlogan) {
        this.logoSlogan = logoSlogan;
        this.secondInputValue = true;
      }

      // 加上这一步
      this.checkFormFilled();
    },
  }
}


</script>

<style>
.my-custom-animation {
  animation: slideInLeft 0.7s ease-in forwards;
}

@keyframes slideInLeft {
  from {
    transform: translateX(50%) translateY(30%) scale(0);
    opacity: 0;
  }

  to {
    transform: translateX(0) translateY(0%) scale(1);
    opacity: 1;
  }
}

@import "EnterBrand.css";
</style>
